import { useState, useRef } from "react";
import { Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";

import { getLocaleText } from "../actions/datagrid";
import { defaultColDef, gridSettings, sideBar, statusBar } from "./grid";
import { importDimensionsGet } from "../api";
import { Button } from "./Button.tsx";

let isFetching = false;

export function ImportDimensionsModal({ hideModal }) {
  const { t } = useTranslation();

  const [fetching, setFetching] = useState(false);
  const [data, setData] = useState([]);

  async function handleImport() {
    if (!isFetching) {
      setFetching((isFetching = true));
      const res = await importDimensionsGet();
      setData(res.data);
      setFetching((isFetching = false));
    }
  }

  const gridRef = useRef();

  const columnDefs = [
    {
      headerName: "DimensionKey",
      field: "codeKey",
      cellRenderer: "agGroupCellRenderer",
    },
    {
      headerName: "DimensionName",
      field: "name",
    },
  ];

  return (
    <Modal show onHide={hideModal} backdrop="static" size="xl" fullscreen="lg-down">
      <Modal.Header closeButton>
        <Modal.Title>{t("ImportDimensionsFromEsalary", "Tuo dimensiot ePalkoista")}</Modal.Title>
      </Modal.Header>

      <Modal.Body className="d-flex" style={{ height: "50vh" }}>
        <Row className="styles-ag flex-grow-1 ag-theme-material">
          <AgGridReact
            {...gridSettings}
            loading={fetching}
            ref={gridRef}
            columnDefs={columnDefs}
            defaultColDef={{ ...defaultColDef, flex: 1 }}
            sideBar={sideBar}
            rowData={data}
            statusBar={statusBar}
            getRowId={(params) => String(params.data.codeListId)}
            getLocaleText={(params) => getLocaleText(t, params)}
            animateRows
            suppressCellFocus
            enableCellTextSelection
            masterDetail
            detailRowAutoHeight
            detailCellRendererParams={{
              detailGridOptions: {
                columnDefs: [
                  {
                    field: "codeKey",
                    cellRenderer: "agGroupCellRenderer",
                  },
                  {
                    field: "codeValue",
                  },
                ],
                defaultColDef: {
                  flex: 1,
                },
              },
              getDetailRowData: (params) => params.successCallback(params.data.items),
            }}
            debug={import.meta.env.DEV}
          />
        </Row>
      </Modal.Body>

      <Modal.Footer>
        <Button testId="close" variant="secondary" onClick={hideModal}>
          {t("Close", "Sulje")}
        </Button>
        <Button testId="import" variant="primary" onClick={handleImport} disabled={fetching}>
          {t("Import", "Tuo")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
